import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ResetPasswordComponent } from '../reset-password/reset-password.component';
import { DataService } from '../../shared/data.service';
import { UtilsService } from '../../shared/utils.service';
import { AlertDialogComponent } from '../../shared/alert-dialog/alert-dialog.component';

@Component({
    selector: 'app-forget-password',
    templateUrl: './forget-password.component.html',
    styleUrls: ['./forget-password.component.scss'],
    standalone: false
})
export class ForgetPasswordComponent implements OnInit {
  forgetPasswordForm: FormGroup;

  constructor(public dialog: MatDialog, private dataService: DataService, private utils: UtilsService) { }

  ngOnInit(): void {
    this.utils.setTitle('Forget Password');
    this.forgetPasswordForm = new FormGroup({
      email: new FormControl(null, [Validators.required, Validators.email, this.utils.isValidEmail.bind(this)]),
    });
  }

  closeDialog() {
    if (this.forgetPasswordForm.dirty) {
      const dialogRef = this.dialog.open(AlertDialogComponent, {
        disableClose: true,
        width: '400px',
        data: {
          title: 'Warning',
          type: 'Warn',
          message: 'You will miss your information once you close',
          buttonText: 'cancel',
          numberOfButtons: 2,
          seconButtonText: 'Ok'
        }
      });
      dialogRef.afterClosed().subscribe((status) => {
        if (status === 'Ok') {
          this.dialog.closeAll();
        }
      });
    } else {
      this.dialog.closeAll();
    }
  }

  onSubmit() {
    const payload = {
      Email: this.forgetPasswordForm.get('email')?.value
    };
    if (this.forgetPasswordForm.valid) {
      this.dialog.closeAll();
      this.dataService.post('auth/ForgotPassword', payload).then((data) => {
        if (data.statusCode === 200) {
          const dialogRef = this.dialog.open(AlertDialogComponent, {
            disableClose: true,
            width: '400px',
            data: {
              title: 'Email sent successfully',
              type: 'Success',
              message: 'An email sent successfully, please check your email',
              buttonText: 'Ok'
            }
          });
        }  else if (data.statusCode === 619 ) {
          this.dialog.closeAll();
          const dialogRef = this.dialog.open(AlertDialogComponent, {
            disableClose: true,
            width: '400px',
            data: {
              title: 'Error',
              type: 'Error',
              message: 'You have exceeded the allowed number to asking about forget the password! Please try again later.',
              buttonText: 'Ok'
            }
          });
        }
        else {
          const dialogRef = this.dialog.open(AlertDialogComponent, {
            disableClose: true,
            width: '400px',
            data: {
              title: 'Error',
              type: 'Error',
              message: 'Something went wrong, please try again!',
              buttonText: 'Ok'
            }
          });
        }
      });
    }
  }

}
